// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__16IuT","icon":"Item_icon__3zii-","selected":"Item_selected__3d2Wz","body":"Item_body__1MYiR"};